// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgenciasRouteImport } from './routes/agencias'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as EmpresasDeServiciosRouteImport } from './routes/empresas-de-servicios'
import { Route as GeneradorLinkWhatsappRouteImport } from './routes/generador-link-whatsapp'
import { Route as NosotrosRouteImport } from './routes/nosotros'
import { Route as PreciosRouteImport } from './routes/precios'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as ProgramaAfiliadosRouteImport } from './routes/programa-afiliados'
import { Route as ReembolsoRouteImport } from './routes/reembolso'
import { Route as SolucionesRouteImport } from './routes/soluciones'
import { Route as TeVamosALlamarRouteImport } from './routes/te-vamos-a-llamar'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as TestimoniosRouteImport } from './routes/testimonios'
import { Route as TrabajosRouteImport } from './routes/trabajos'
import { Route as TusDatosRouteImport } from './routes/tus-datos'
import { Route as VslRouteImport } from './routes/vsl'
import { Route as WhatsappLinkGeneratorRouteImport } from './routes/whatsapp-link-generator'
import { Route as QueHacemosAgenteIaRouteImport } from './routes/que-hacemos/agente-ia'
import { Route as QueHacemosCampanasWhatsappRouteImport } from './routes/que-hacemos/campanas-whatsapp'
import { Route as QueHacemosEmbudo5EstrellasRouteImport } from './routes/que-hacemos/embudo-5-estrellas'
import { Route as QueHacemosInboxUnificadoRouteImport } from './routes/que-hacemos/inbox-unificado'
import { Route as QueHacemosSeguimientoAutomaticoRouteImport } from './routes/que-hacemos/seguimiento-automatico'
import { Route as QueHacemosSeoLocalRouteImport } from './routes/que-hacemos/seo-local'
import { Route as QueHacemosSitioWebRouteImport } from './routes/que-hacemos/sitio-web'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgenciasRoute = AgenciasRouteImport.update({
            id: '/agencias',path: '/agencias',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const EmpresasDeServiciosRoute = EmpresasDeServiciosRouteImport.update({
            id: '/empresas-de-servicios',path: '/empresas-de-servicios',getParentRoute: () => rootRouteImport
          })
const GeneradorLinkWhatsappRoute = GeneradorLinkWhatsappRouteImport.update({
            id: '/generador-link-whatsapp',path: '/generador-link-whatsapp',getParentRoute: () => rootRouteImport
          })
const NosotrosRoute = NosotrosRouteImport.update({
            id: '/nosotros',path: '/nosotros',getParentRoute: () => rootRouteImport
          })
const PreciosRoute = PreciosRouteImport.update({
            id: '/precios',path: '/precios',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const ProgramaAfiliadosRoute = ProgramaAfiliadosRouteImport.update({
            id: '/programa-afiliados',path: '/programa-afiliados',getParentRoute: () => rootRouteImport
          })
const ReembolsoRoute = ReembolsoRouteImport.update({
            id: '/reembolso',path: '/reembolso',getParentRoute: () => rootRouteImport
          })
const SolucionesRoute = SolucionesRouteImport.update({
            id: '/soluciones',path: '/soluciones',getParentRoute: () => rootRouteImport
          })
const TeVamosALlamarRoute = TeVamosALlamarRouteImport.update({
            id: '/te-vamos-a-llamar',path: '/te-vamos-a-llamar',getParentRoute: () => rootRouteImport
          })
const TerminosRoute = TerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => rootRouteImport
          })
const TestimoniosRoute = TestimoniosRouteImport.update({
            id: '/testimonios',path: '/testimonios',getParentRoute: () => rootRouteImport
          })
const TrabajosRoute = TrabajosRouteImport.update({
            id: '/trabajos',path: '/trabajos',getParentRoute: () => rootRouteImport
          })
const TusDatosRoute = TusDatosRouteImport.update({
            id: '/tus-datos',path: '/tus-datos',getParentRoute: () => rootRouteImport
          })
const VslRoute = VslRouteImport.update({
            id: '/vsl',path: '/vsl',getParentRoute: () => rootRouteImport
          })
const WhatsappLinkGeneratorRoute = WhatsappLinkGeneratorRouteImport.update({
            id: '/whatsapp-link-generator',path: '/whatsapp-link-generator',getParentRoute: () => rootRouteImport
          })
const QueHacemosAgenteIaRoute = QueHacemosAgenteIaRouteImport.update({
            id: '/que-hacemos/agente-ia',path: '/que-hacemos/agente-ia',getParentRoute: () => rootRouteImport
          })
const QueHacemosCampanasWhatsappRoute = QueHacemosCampanasWhatsappRouteImport.update({
            id: '/que-hacemos/campanas-whatsapp',path: '/que-hacemos/campanas-whatsapp',getParentRoute: () => rootRouteImport
          })
const QueHacemosEmbudo5EstrellasRoute = QueHacemosEmbudo5EstrellasRouteImport.update({
            id: '/que-hacemos/embudo-5-estrellas',path: '/que-hacemos/embudo-5-estrellas',getParentRoute: () => rootRouteImport
          })
const QueHacemosInboxUnificadoRoute = QueHacemosInboxUnificadoRouteImport.update({
            id: '/que-hacemos/inbox-unificado',path: '/que-hacemos/inbox-unificado',getParentRoute: () => rootRouteImport
          })
const QueHacemosSeguimientoAutomaticoRoute = QueHacemosSeguimientoAutomaticoRouteImport.update({
            id: '/que-hacemos/seguimiento-automatico',path: '/que-hacemos/seguimiento-automatico',getParentRoute: () => rootRouteImport
          })
const QueHacemosSeoLocalRoute = QueHacemosSeoLocalRouteImport.update({
            id: '/que-hacemos/seo-local',path: '/que-hacemos/seo-local',getParentRoute: () => rootRouteImport
          })
const QueHacemosSitioWebRoute = QueHacemosSitioWebRouteImport.update({
            id: '/que-hacemos/sitio-web',path: '/que-hacemos/sitio-web',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgenciasRoute: AgenciasRoute,DemoRoute: DemoRoute,EmpresasDeServiciosRoute: EmpresasDeServiciosRoute,GeneradorLinkWhatsappRoute: GeneradorLinkWhatsappRoute,NosotrosRoute: NosotrosRoute,PreciosRoute: PreciosRoute,PrivacidadRoute: PrivacidadRoute,ProgramaAfiliadosRoute: ProgramaAfiliadosRoute,ReembolsoRoute: ReembolsoRoute,SolucionesRoute: SolucionesRoute,TeVamosALlamarRoute: TeVamosALlamarRoute,TerminosRoute: TerminosRoute,TestimoniosRoute: TestimoniosRoute,TrabajosRoute: TrabajosRoute,TusDatosRoute: TusDatosRoute,VslRoute: VslRoute,WhatsappLinkGeneratorRoute: WhatsappLinkGeneratorRoute,QueHacemosAgenteIaRoute: QueHacemosAgenteIaRoute,QueHacemosCampanasWhatsappRoute: QueHacemosCampanasWhatsappRoute,QueHacemosEmbudo5EstrellasRoute: QueHacemosEmbudo5EstrellasRoute,QueHacemosInboxUnificadoRoute: QueHacemosInboxUnificadoRoute,QueHacemosSeguimientoAutomaticoRoute: QueHacemosSeguimientoAutomaticoRoute,QueHacemosSeoLocalRoute: QueHacemosSeoLocalRoute,QueHacemosSitioWebRoute: QueHacemosSitioWebRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)